var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psPatientsListAllWeights"},[_c('el-table',{attrs:{"data":_vm.allWeights,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"date","label":"Fecha"}}),_c('el-table-column',{attrs:{"prop":"groupDescription","label":"Grupo","width":"160"}}),_c('el-table-column',{attrs:{"prop":"weight","label":"Peso"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }